export default __webpack_public_path__ + "static/media/settings.c04d465b.svg";